import { useEffect, useState } from 'react';

import type { ProgressbarProps } from './Progressbar.types';

import { S } from './Progressbar.styles';

export const Progressbar = ({ steps, activeStep }: ProgressbarProps) => {
  const [progressPercent, setProgressPercent] = useState(0);

  useEffect(() => {
    const stepWidth = 100 / steps.length;

    if (activeStep === 0) {
      setProgressPercent(stepWidth);
    } else if (activeStep >= steps.length - 1) {
      setProgressPercent(100);
    } else {
      setProgressPercent((activeStep + 1) * stepWidth);
    }
  }, [activeStep, steps.length]);

  return (
    <S.Wrapper>
      <S.Progressbar>
        <S.ProgressbarFill $progressPercent={progressPercent} />
      </S.Progressbar>

      <S.Steps>
        {steps.map((_, index) => (
          <S.Step key={index} />
        ))}
      </S.Steps>
    </S.Wrapper>
  );
};
